import { adjustColorForProperContrast } from '~/components/AccessibleColorPicker/color-palette-logic';
import type {
  RegistrationCustomizationsWithGeneratedValues,
  RegistrationCustomizationsInheritedFromBrand,
} from './Brand/types';
import { getSlightAccentedBackgroundColor } from './utilities/colorGen';
import { getGeneratedValuesForBrand } from './utilities/getGeneratedValuesForBrand';

export const generateRegistrationThemeValues = (
  registrationCustomizations: RegistrationCustomizationsInheritedFromBrand,
): RegistrationCustomizationsWithGeneratedValues => {
  const { backgroundColor } = registrationCustomizations;

  const updatedBrand = getGeneratedValuesForBrand({
    ...registrationCustomizations,
    backgroundColor,
  });

  const dateTimeBackgroundColor = getSlightAccentedBackgroundColor(backgroundColor);

  const dateTimeTextColor = adjustColorForProperContrast(
    dateTimeBackgroundColor,
    dateTimeBackgroundColor,
  );

  return {
    ...registrationCustomizations,
    ...updatedBrand,
    dateTimeBackgroundColor,
    dateTimeTextColor,
    formBackgroundColor: updatedBrand.slightAccentedBackgroundColor, // This is needed for the post-submission state for 3rd party forms
    formTextColor: updatedBrand.slightAccentedTextColor, // This is needed for the post-submission state for 3rd party forms
  };
};
